import React from 'react';
import { QuestionIds } from '../data/constants/QuestionIds';
import { CustomQuestion, Question, QuestionTypes } from './Question';
import { AboutYouProof } from './aboutyouproof/AboutYouProof';
import { AnalysisLoader } from './analysisloader/AnalysisLoader';
import { ColorQuestionComponent } from './colors/ColorQuestionComponent';
import { ImageQuestionComponent } from './image/ImageQuestionComponent';
import { ImageLoader } from './imageloader/ImageLoader';
import { InfoComponent } from './info/InfoComponent';
import { OptionalComponent } from './info/OptionalComponent';
import { YoYoGraph } from './yoyo/YoYoGraph';
import { Motivation } from './motivation/Motivation';
import { MeqResults } from './meqresults/MeqResults';
import { OptionQuestionComponent } from './options/OptionQuestionComponent';
import { ProductivityGraph } from './productivitygraph/ProductivityGraph';
import { StatementQuestionComponent } from './statement/StatementQuestionComponent';
import { GadResults } from './gadresults/GadResults';
import { PlaceQuestionComponent } from './places/PlaceComponents';
import { QuestionComponentProps } from './QuestionComponent.types';
import { Personalization } from './personalization/Personalization';
import { MeqResultsV2 } from './meqresults/meqresultsv2/MeqResultsV2';
import { PersonalizationD3 } from './personalizationd3/PersonalizationD3';
import { EducationAnswerComponent } from './eduanswer/EducationAnswerComponent';
import { InsomniaResults } from './insomniaresults/InsomniaResults';
import { LivenChose } from './livenchose/LivenChose';
import { LivenStatementQuestionComponent } from 'onboarding/question/livenstatement/LivenStatementQuestionComponent';
import { LivenOptionQuestionComponent } from './livenoptions/LivenOptionQuestionComponent';
import { LivenResearch } from './livenresearch/LivenResearch';
import { ExpertContent } from './expertcontent/ExpertContent';
import { OverPeople } from './overpeople/OverPeople';
import { LivenAnalysisLoader } from './livenanalysisloader/LivenAnalysisLoader';
import { LivenProfileSummary } from './livenprofilesummary/LivenProfileSummary';
import { PlanDesigned } from './plandesigned/PlanDesigned';
import { AnxietyLevel } from './anxietylevel/AnxietyLevel';
import { CreoQuizComponent } from './creoquiz/CreoQuizQuestion';
import { AchievePotential } from './achievepotential/AchievePotential';

export const getQuestionComponent = (
  question: Question,
  isMeqResultAnimalFlow?: boolean,
  isMeqResultV2Flow?: boolean,
): React.FC<QuestionComponentProps<any>> => {
  switch (question.type) {
    case QuestionTypes.Optional:
      return OptionalComponent;
    case QuestionTypes.Option:
      return OptionQuestionComponent;
    case QuestionTypes.LivenOption:
      return LivenOptionQuestionComponent;
    case QuestionTypes.Color:
      return ColorQuestionComponent;
    case QuestionTypes.Places:
      return PlaceQuestionComponent;
    case QuestionTypes.Info:
      return InfoComponent;
    case QuestionTypes.Statement:
      return StatementQuestionComponent;
    case QuestionTypes.Image:
      return ImageQuestionComponent;
    case QuestionTypes.EduAnswer:
      return EducationAnswerComponent;
    case QuestionTypes.LivenStatement:
      return LivenStatementQuestionComponent;
    case QuestionTypes.Custom:
      switch ((question as CustomQuestion).variationId) {
        case QuestionIds.AboutYouProof1:
          return AboutYouProof;
        case QuestionIds.SleepAndActivityProof1:
          return YoYoGraph;
        case QuestionIds.SleepAndActivityProof2:
          return Motivation;
        case QuestionIds.SleepAndActivityLoader:
          return ImageLoader;
        case QuestionIds.PersonalizationProof1:
          return ProductivityGraph;
        case QuestionIds.PersonalizationLoader:
          return AnalysisLoader;
        case QuestionIds.PersonalizationD3:
          return PersonalizationD3;
        case QuestionIds.WellbeingQ2:
          return LivenChose;
        case QuestionIds.WellbeingQ20:
          return AchievePotential;
        case QuestionIds.WellbeingQ22:
          return LivenResearch;
        case QuestionIds.WellbeingQ28:
          return ExpertContent;
        case QuestionIds.WellbeingQ29:
          return OverPeople;
        case QuestionIds.WellbeingQ31:
          return LivenProfileSummary;
        case QuestionIds.WellbeingQ32:
          return PlanDesigned;
        case QuestionIds.WellbeingQ33:
          return LivenProfileSummary;
        case QuestionIds.WellbeingQ34:
          return PlanDesigned;
        case QuestionIds.WellbeingQ35:
          return LivenAnalysisLoader;
        case QuestionIds.WellbeingQ36:
          return AnxietyLevel;
        case QuestionIds.MeqResults:
          return isMeqResultV2Flow || isMeqResultAnimalFlow
            ? MeqResultsV2
            : MeqResults;
        case QuestionIds.IsiD1:
          return InsomniaResults;
        case QuestionIds.GadResults:
          return GadResults;
        case QuestionIds.PersonalizationD1:
          return Personalization;
        case QuestionIds.CreoQuizQ2:
          return CreoQuizComponent;
        case QuestionIds.CreoQuizQ3:
          return CreoQuizComponent;
        case QuestionIds.CreoQuizQ4:
          return CreoQuizComponent;
        default:
          return InfoComponent;
      }
    case QuestionTypes.Blitz:
      return InfoComponent;
  }
};
